const PRMS_COLUMNS_HEADERS = {
  prm_number: { sortable: true, searchable: true, integer: true },
  'pre_delivery_note_data.docket_number': {
    sortable: false,
    searchable: false,
  },
  'pre_delivery_note_data.arriving_date': {
    sortable: false,
    searchable: false,
  },
};

const NC_COLUMNS_HEADERS = {
  id: { sortable: true, searchable: true, integer: true },
  ncNumber: { sortable: true, searchable: true },
  openDate: { sortable: true, searchable: false },
  ncType: { sortable: false, searchable: false },
  csvFileName: { sortable: true, searchable: false },
};

const PRMS_BUTTONS = {
  deleteAction: { tooltip: 'deleteAction.prm' },
  viewAction: { tooltip: 'viewAction.prm' },
};

const NC_BUTTONS = {
  downloadCSV: { tooltip: 'downloadCSV.file' },
  deleteAction: { tooltip: 'deleteAction.nc' },
  editAction: { tooltip: 'editAction.nc' },
};

export { PRMS_COLUMNS_HEADERS, NC_COLUMNS_HEADERS, PRMS_BUTTONS, NC_BUTTONS };
